import { defaultTheme } from "./default";
import { koloTheme } from "./kolo";
import { twyfordTheme } from "./twyford";
import { comTheme } from "./geberit-com";
import { nordicsTheme } from "./nordics";
import { xyTheme } from "./xy";
export { defaultTheme, koloTheme, nordicsTheme, twyfordTheme, comTheme, xyTheme, };
export const themes = {
    defaultTheme,
    koloTheme,
    twyfordTheme,
    comTheme,
    nordicsTheme,
    xyTheme,
};
